import { Html, useProgress } from '@react-three/drei';
import { useEffect, useState, useRef } from 'react';

function Loader() {
  const { progress } = useProgress();
  const [displayProgress, setDisplayProgress] = useState(0);
  const [visible, setVisible] = useState(true);

  const hasReached95 = useRef(false);
  const hasReached99 = useRef(false);
  const intervalRef = useRef(null);

  useEffect(() => {
    // Fast progress to 95%
    intervalRef.current = setInterval(() => {
      setDisplayProgress((prev) => {
        if (prev < 95) return prev + 1;
        if (!hasReached95.current) {
          hasReached95.current = true;
          clearInterval(intervalRef.current);

          // After reaching 95%, wait 500ms then jump to 99%
          setTimeout(() => {
            setDisplayProgress(99);
            hasReached99.current = true;
          }, 100);
        }
        return prev;
      });
    }, 1);

    return () => clearInterval(intervalRef.current);
  }, []);

  // Wait for real loading to hit 100%
  useEffect(() => {
    if (progress >= 100 && hasReached99.current) {
      const timeout = setTimeout(() => {
        setDisplayProgress(100);
        setTimeout(() => setVisible(false), 500);
      }, 300); // slight pause for nice UX

      return () => clearTimeout(timeout);
    }
  }, [progress]);

  if (!visible) return null;

  return (
    <Html center>
      <div style={{
        padding: '2rem 3rem',
        borderRadius: '16px',
        color: '#fff',
        fontSize: '1.2rem',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '300px',
        transition: 'opacity 0.3s ease',
      }}>
        <p style={{ marginBottom: '0.5rem' ,color:'black'}}>Loading 3D Model...</p>
        <div style={{
          width: '100%',
          height: '6px',
          background: '#333',
          borderRadius: '3px',
          overflow: 'hidden',
        }}>
          <div style={{
            width: `${displayProgress}%`,
            height: '100%',
            background: '#03C8E8',
            transition: 'width 0.2s ease-in-out',
          }} />
        </div>
        <p style={{ fontSize: '0.9rem', marginTop: '0.5rem',color:'black'}}>
          {Math.floor(displayProgress)}%
        </p>
      </div>
    </Html>
  );
}

export default Loader;
